import axios from "axios";
import {Progress} from "../../../administration/model";
import {RelaunchStep} from "../../../administration/service/sourcingService";

const url = (tenantId: string, endpoint: string): string => {
    return tenantId
        ? `/api/sourcing/${tenantId}${endpoint}`
        : `/api/sourcing${endpoint}`
}

const getProgress = async (page: number, pageSize: number, tenantId?: string, orderType?: 'LAST_UPDATED' | 'CREATION_DATE'): Promise<Array<Progress>> => {
    const from = pageSize * (page - 1);
    return axios
        .get(url(tenantId ? tenantId : "*", `/_counters?from=${from}&pageSize=${pageSize}&orderType=${orderType}`),)
        .then(response => response.data);
}

const cancelAll = async (tenantId?: string) => {
    return axios
        .get(url(tenantId, '/*/_cancel'))
        .then(response => response.data);
}

const deleteAll = async (tenantId?: string) => {
    return axios
        .delete(url(tenantId, '/*/_delete'))
        .then(response => response.data);
}

const replayAll = async (tenantId?: string) => {
    return axios
        .get(url(tenantId, '/*/_replay/vecko-feedback-api'))
        .then(response => response.data);
}

const reindex = (tenantId?: string) => {
    return axios
        .get('/api/sourcing/_reindex/' + tenantId)
        .then(response => response);
};

const reindexStreams = () => {
    return axios
        .get('/api/sourcing/streams/_reindex')
        .then(response => response);
};

const cleanup = async (tenantId?: string) => {
    return axios
        .get(url(tenantId, '/_cleanup'))
        .then(response => response.data);
}

const cancelStream = (stream: string, tenantId?: string) => {
    return axios
        .get(url(tenantId, `/${stream}/_cancel`))
        .then(response => response.data);
}

const deleteStream = (stream: string, tenantId?: string) => {
    return axios
        .delete(url(tenantId, `/${stream}/_delete`))
        .then(response => response.data);
}

const replayStream = (stream: string, tenantId?: string) => {
    return axios
        .get(url(tenantId, `/${stream}/_replay/vecko-feedback-api`))
        .then(response => response.data);
}

const relaunchProcess = (tenantId: string, stream: string, id: string, step: RelaunchStep) => {
    return axios
        .get(url(null, `/tenant/${tenantId}/stream/${stream}/id/${id}/_relaunch?step=${step}`),)
        .then(response => response.data);
}

export default {
    getProgress,
    cancelAll,
    deleteAll,
    replayAll,
    cleanup,
    cancelStream,
    deleteStream,
    replayStream,
    reindex,
    reindexStreams,
    relaunchProcess
};
